import { useRequiredContext } from "@redotech/react-util/context";
import { useEffect } from "react";
import * as styles from "./due-later.module.css";
import { CART_TOTAL_SELECTOR } from "./selectors";
import {
  TryFirstModificationsContext,
  useShouldRefreshCartModifications,
} from "./try-first-cart-modifications";

const DueLater = () => {
  const { tryFirstTotal, dueTodayTotal, currency, formatCurrency } =
    useRequiredContext(TryFirstModificationsContext);
  const refreshCartModifications = useShouldRefreshCartModifications();

  useEffect(() => {
    const targetElement = document.querySelector(
      CART_TOTAL_SELECTOR,
    ) as HTMLElement;

    const shouldShowCustomTotal = tryFirstTotal > 0 && !!targetElement;

    if (shouldShowCustomTotal && !targetElement.dataset.redoDisplayReset) {
      targetElement.dataset.redoDisplayReset = targetElement.style.display;
      targetElement.style.display = "none";
    } else if (targetElement) {
      targetElement.style.display =
        targetElement.dataset.redoDisplayReset || "";
      delete targetElement.dataset.redoDisplayReset;
    }

    return () => {
      if (targetElement && targetElement.dataset.redoDisplayReset) {
        targetElement.style.display = targetElement.dataset.redoDisplayReset;
        delete targetElement.dataset.redoDisplayReset;
      }
    };
  }, [tryFirstTotal, dueTodayTotal, refreshCartModifications]);

  if (tryFirstTotal === 0) {
    return null;
  }

  return (
    <div className={styles.dueLaterContainer}>
      <div className={styles.dueNowText}>
        <div>Total Due Now:</div>
        <div>{formatCurrency(dueTodayTotal, currency)}</div>
      </div>
      <div className={styles.dueLaterText}>
        <div>Due Later:</div>
        <div>{formatCurrency(tryFirstTotal, currency)}</div>
      </div>
    </div>
  );
};

export default DueLater;
